import { useConfigStore } from '@packages/stores';

import { Assets } from '@assets';
import { Button } from '@elements/button';
import { Text } from '@elements/text';
import { TextWithMd } from '@elements/text/textWithMd';
import { i18n } from '@i18n';

export const Maintenance = () => {
  const description = useConfigStore(
    state => state?.regionSpecificConfig?.FREELY_OUTAGE_WINDOW_DESCRIPTION,
  );
  const termsAndConditions = useConfigStore(
    state => state?.regionSpecificConfig?.FREELY_OUTAGE_WINDOW_TERMS_AND_CONDITIONS,
  );
  return (
    <div className="bg-nusa-100 py-8 sm:py-0 flex min-h-screen w-screen flex-col items-center justify-center space-y-7 px-4 text-center">
      <Assets.Tools />
      <Text variant="h2-36/sb">{i18n.t('maintenanceModal.heading')}</Text>
      <Text variant="body-16/m">{i18n.t('maintenanceModal.subHeading')}</Text>
      {description && <TextWithMd variant="body-16/m">{description}</TextWithMd>}
      <div className="border-y border-fuji-800 border-opacity-20 p-7 text-center">
        <Text variant="subHeading-14/m">{i18n.t('maintenanceModal.emergencyMessage')}</Text>
        <a href={`tel:${i18n.t('maintenanceModal.emergencyNumber')}`} className="w-full">
          <Button
            variant="primary"
            className="mt-6 w-full"
            title={i18n.t('maintenanceModal.emergencyNumber')}
          />
        </a>
      </div>
      {termsAndConditions && (
        <TextWithMd className="max-w-2xl" variant="footnote-12/r">
          {termsAndConditions}
        </TextWithMd>
      )}
    </div>
  );
};
